document.addEventListener("DOMContentLoaded", function () {
  // Get query parameters
  const urlParams = new URLSearchParams(window.location.search);
  const collectionHandle = urlParams.get("collection");
  let sortDirection = urlParams.get("sort") || "asc";
  const productsPerPage = 24; // Adjust as needed
  let currentPage = parseInt(urlParams.get("page")) || 1;

  // Elements
  const loadingOverlay = document.getElementById("loading-overlay");
  const errorContainer = document.getElementById("error-container");
  const errorMessage = document.getElementById("error-message");
  const retryButton = document.getElementById("retry-button");
  const productGrid = document.getElementById("product-grid");
  const productCount = document.getElementById("product-count");
  const productCountContainer = document.getElementById(
    "product-count-container"
  );
  const collectionTitle = document.getElementById("collection-title");
  const viewNormalLink = document.getElementById("view-normal-link");
  const sortLowHigh = document.getElementById("sort-low-high");
  const sortHighLow = document.getElementById("sort-high-low");
  const paginationElement = document.getElementById("pagination");
  const hideSoldOutCheckbox = document.getElementById("hide-sold-out");

  // State
  let allProducts = [];
  let collectionData = null;
  let isLoading = true;
  let hideSoldOut = localStorage.getItem("hideSoldOut") === "true";
  let inventoryTracking = {}; // Track inventory to prevent exceeding stock
  let lineItems = {}; // Track items in cart for inventory tracking

  // Toggle sort buttons
  function updateSortButtons() {
    if (sortDirection === "asc") {
      sortLowHigh.classList.add("active-sort");
      sortHighLow.classList.remove("active-sort");
    } else {
      sortHighLow.classList.add("active-sort");
      sortLowHigh.classList.remove("active-sort");
    }
  }

  // Show/hide loading
  function updateLoadingState() {
    loadingOverlay.style.display = isLoading ? "flex" : "none";
  }

  // Show error
  function showError(
    message = "Sorry, there was an error loading products. Please try again."
  ) {
    errorMessage.textContent = message;
    errorContainer.style.display = "block";
  }

  // Hide error
  function hideError() {
    errorContainer.style.display = "none";
  }

  // Show notification using Bootstrap Notify or similar
  function showNotification(message, isSuccess = true) {
    // Check if $.notify exists (Bootstrap Notify)
    if (typeof $.notify === "function") {
      $.notify(
        {
          message: message,
        },
        {
          type: isSuccess ? "success" : "danger",
          placement: {
            from: "top",
            align: "center",
          },
          offset: 0,
          spacing: 10,
          z_index: 9999,
          delay: 3000,
          animate: {
            enter: "animated fadeInDown",
            exit: "animated fadeOutUp",
          },
        }
      );
    } else {
      // Fallback to creating a custom notification
      const notification = document.createElement("div");
      notification.className = `custom-notification col-xs-12 alert ${
        isSuccess ? "alert-success" : "alert-danger"
      } animated fadeInDown`;
      notification.setAttribute("role", "alert");
      notification.setAttribute("data-notify-position", "top-center");
      notification.style.cssText =
        "display: inline-block; margin: 0px auto; position: fixed; transition: 0.5s ease-in-out; z-index: 9999; top: 0px; left: 0px; right: 0px;";

      notification.innerHTML = `
        <button type="button" aria-hidden="true" class="close" data-notify="dismiss" style="position: absolute; right: 10px; top: 5px; z-index: 10001;">×</button>
        <span data-notify="icon"></span> 
        <span data-notify="title"></span> 
        <span data-notify="message">${message}</span>
        <a href="#" target="_blank" data-notify="url"></a>
      `;

      document.body.appendChild(notification);

      // Add event listener to close button
      notification
        .querySelector(".close")
        .addEventListener("click", function () {
          notification.remove();
        });

      // Auto-hide after 3 seconds
      setTimeout(() => {
        notification.classList.remove("fadeInDown");
        notification.classList.add("fadeOutUp");
        setTimeout(() => {
          notification.remove();
        }, 500);
      }, 3000);
    }
  }

  // If no collection handle is provided, show error
  if (!collectionHandle) {
    collectionTitle.textContent = "Error: No Collection Selected";
    isLoading = false;
    updateLoadingState();
    showError("No collection was specified. Please select a collection.");
    return;
  }

  // Set up retry button
  retryButton.addEventListener("click", function () {
    hideError();
    isLoading = true;
    updateLoadingState();
    fetchCollection();
  });

  // Set up hide sold out checkbox
  hideSoldOutCheckbox.checked = hideSoldOut;
  hideSoldOutCheckbox.addEventListener("change", function () {
    hideSoldOut = this.checked;
    localStorage.setItem("hideSoldOut", hideSoldOut);
    currentPage = 1; // Reset to first page when filter changes
    renderProducts();
  });

  // Set up sort buttons
  sortLowHigh.addEventListener("click", function () {
    if (sortDirection !== "asc") {
      sortDirection = "asc";
      updateSortButtons();
      updateURL();
      sortProducts();
      renderProducts();
    }
  });

  sortHighLow.addEventListener("click", function () {
    if (sortDirection !== "desc") {
      sortDirection = "desc";
      updateSortButtons();
      updateURL();
      sortProducts();
      renderProducts();
    }
  });

  // Update URL parameters without reload
  function updateURL() {
    const url = new URL(window.location.href);
    url.searchParams.set("sort", sortDirection);
    url.searchParams.set("page", currentPage);
    history.pushState(
      {
        page: currentPage,
        sort: sortDirection,
      },
      "",
      url.toString()
    );
  }

  // Check if we need to update the cache (older than 24 hours)
  function isCacheStale(timestamp) {
    if (!timestamp) return true;

    // Calculate if the cache is older than 24 hours
    const cacheAge = Date.now() - timestamp;
    const hoursInMilliseconds = 24 * 60 * 60 * 1000; // 24 hours
    return cacheAge > hoursInMilliseconds;
  }

  // Try getting from cache first
  function getFromCache() {
    const cacheKey = `card-sorted-${collectionHandle}-products`;
    const cachedData = localStorage.getItem(cacheKey);
    if (cachedData) {
      try {
        const data = JSON.parse(cachedData);
        // Check if cache is still valid (less than 24 hours old)
        if (!isCacheStale(data.timestamp)) {
          console.log("Using cached collection data");
          collectionData = data.collection;
          allProducts = data.products;

          // Update title and collection link when using cached data
          document.title = collectionData.title + " - Sorted by Card Number";
          collectionTitle.textContent =
            collectionData.title + " - Sorted by Card Number";
          viewNormalLink.href = `/collections/${collectionHandle}`;

          // Initialize inventory tracking
          if (data.inventoryTracking) {
            inventoryTracking = data.inventoryTracking;
          } else {
            // Build inventory tracking from product variants
            initializeInventoryTracking();
          }
          return true;
        } else {
          console.log("Cache is stale, fetching fresh data");
        }
      } catch (e) {
        console.error("Error parsing cached data:", e);
      }
    }
    return false;
  }

  // Initialize inventory tracking from product variants
  function initializeInventoryTracking() {
    inventoryTracking = {};
    allProducts.forEach((product) => {
      product.variants.forEach((variant) => {
        inventoryTracking[variant.id] = {
          inventory_quantity: variant.inventory_quantity || 0,
          inventory_management: variant.inventory_management || null,
          inventory_policy: variant.inventory_policy || "deny",
          available: variant.available,
        };
      });
    });
  }

  // Get current cart data to track inventory
  function getCartData() {
    return fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        // Update line items with cart data
        lineItems = {};
        cart.items.forEach((item) => {
          lineItems[item.variant_id] =
            (lineItems[item.variant_id] || 0) + item.quantity;
        });
        return cart;
      })
      .catch((error) => {
        console.error("Error fetching cart:", error);
        return { items: [], item_count: 0 };
      });
  }

  // Save to cache
  function saveToCache() {
    const cacheKey = `card-sorted-${collectionHandle}-products`;
    try {
      localStorage.setItem(
        cacheKey,
        JSON.stringify({
          collection: collectionData,
          products: allProducts,
          inventoryTracking: inventoryTracking,
          timestamp: Date.now(),
        })
      );
    } catch (e) {
      console.warn("Could not cache products:", e);
    }
  }

  // Fetch collection data
  function fetchCollection() {
    isLoading = true;
    updateLoadingState();
    hideError();

    // Check cache first
    if (getFromCache()) {
      // Get cart data to track inventory
      getCartData().then(() => {
        setupCollectionPage();
      });
      return;
    }

    // First, get basic collection info
    fetch(`/collections/${collectionHandle}.json`)
      .then((response) => {
        if (!response.ok)
          throw new Error(`HTTP error! Status: ${response.status}`);
        return response.json();
      })
      .then((data) => {
        console.log("Collection info loaded:", data);
        collectionData = data.collection;

        // Update title and link
        document.title = collectionData.title + " - Sorted by Card Number";
        collectionTitle.textContent =
          collectionData.title + " - Sorted by Card Number";
        viewNormalLink.href = "/collections/" + collectionHandle;

        // Now get all products
        return fetchAllProducts();
      })
      .catch((error) => {
        console.error("Error fetching collection:", error);
        isLoading = false;
        updateLoadingState();
        showError("Error loading collection information. Please try again.");
      });
  }

  // Function to fetch all products in the collection using pagination
  function fetchAllProducts() {
    allProducts = [];
    inventoryTracking = {};
    let page = 1;
    const limit = 250; // Maximum allowed by Shopify API

    // Function to recursively fetch all pages
    function fetchPage(page) {
      return fetch(
        `/collections/${collectionHandle}/products.json?limit=${limit}&page=${page}`
      )
        .then((response) => {
          if (!response.ok)
            throw new Error(`HTTP error! Status: ${response.status}`);
          return response.json();
        })
        .then((data) => {
          console.log(
            `Loaded page ${page} with ${data.products.length} products`
          );

          // Process the products
          data.products.forEach((product) => {
            // Extract card number from title using regex
            let cardNumber = null;

            // Try to extract from title format like "123/198"
            const match = product.title.match(/(\d+)\/\d+/);
            if (match) {
              cardNumber = parseFloat(match[1]);
            }

            // Check if ANY variant is available instead of just the product's general availability
            const hasAvailableVariant = product.variants.some(
              (variant) => variant.available
            );

            // Initialize inventory tracking for each variant
            product.variants.forEach((variant) => {
              // Store the inventory information
              inventoryTracking[variant.id] = {
                inventory_quantity: variant.inventory_quantity || 0,
                inventory_management: variant.inventory_management || null,
                inventory_policy: variant.inventory_policy || "deny",
                available: variant.available,
              };
            });

            // Create product object with all needed data
            allProducts.push({
              id: product.id,
              title: product.title,
              handle: product.handle,
              url: `/products/${product.handle}`,
              available: hasAvailableVariant, // Use our custom availability check
              featured_image:
                product.images.length > 0 ? product.images[0].src : "",
              second_image:
                product.images.length > 1 ? product.images[1].src : null,
              price: product.variants[0].price * 100, // Convert to cents
              compare_at_price: product.variants[0].compare_at_price
                ? product.variants[0].compare_at_price * 100
                : null,
              variants: product.variants,
              on_sale:
                product.variants[0].compare_at_price &&
                product.variants[0].compare_at_price >
                  product.variants[0].price,
              card_number: cardNumber,
              tags: product.tags,
              type: product.product_type,
            });
          });

          // If there are more products, fetch the next page
          if (
            data.products.length === limit &&
            page * limit < collectionData.products_count
          ) {
            page++;
            return fetchPage(page);
          } else {
            // Get cart data to track inventory
            return getCartData().then(() => {
              // All products loaded
              // Save to cache
              saveToCache();
              return setupCollectionPage();
            });
          }
        });
    }

    return fetchPage(page);
  }

  // Set up collection page with fetched data
  function setupCollectionPage() {
    console.log(`All ${allProducts.length} products loaded`);

    // Sort products
    sortProducts();

    // Show product count
    productCount.textContent = allProducts.length;
    productCountContainer.style.display = "block";

    // Render products
    isLoading = false;
    updateLoadingState();
    renderProducts();
    updateSortButtons();
  }

  // Sort products by card number
  function sortProducts() {
    allProducts.sort((a, b) => {
      const aCardNumber =
        a.card_number !== null ? parseFloat(a.card_number) : 999999;
      const bCardNumber =
        b.card_number !== null ? parseFloat(b.card_number) : 999999;

      return sortDirection === "desc"
        ? bCardNumber - aCardNumber
        : aCardNumber - bCardNumber;
    });
  }

  // Helper function to format money
  function formatMoney(cents) {
    const dollars = (cents / 100).toFixed(2);
    return `$${dollars} AUD`;
  }

  // Check if a variant is available based on inventory tracking
  function isVariantAvailable(variantId) {
    if (!inventoryTracking[variantId]) return false;

    // Get the inventory information
    const inventory = inventoryTracking[variantId];

    // If inventory management is not Shopify, assume it's available
    if (inventory.inventory_management !== "shopify") return true;

    // If inventory policy is continue, it's always available
    if (inventory.inventory_policy === "continue") return true;

    // Check if there's enough quantity left
    const cartQuantity = lineItems[variantId] || 0;
    return inventory.inventory_quantity > cartQuantity;
  }

  // Calculate available quantity for a variant
  function getAvailableQuantity(variantId) {
    if (!inventoryTracking[variantId]) return 0;

    const inventory = inventoryTracking[variantId];

    // If inventory management is not Shopify or policy is continue, assume unlimited
    if (
      inventory.inventory_management !== "shopify" ||
      inventory.inventory_policy === "continue"
    ) {
      return 9999; // Effectively unlimited
    }

    // Return available quantity after subtracting cart items
    const cartQuantity = lineItems[variantId] || 0;
    return Math.max(0, inventory.inventory_quantity - cartQuantity);
  }

  // Generate variant price data for all variants of a product
  function generateVariantPriceData(variants) {
    const variantData = {};

    variants.forEach((variant) => {
      variantData[variant.id] = {
        price: variant.price * 100,
        compareAtPrice: variant.compare_at_price
          ? variant.compare_at_price * 100
          : null,
      };
    });

    return JSON.stringify(variantData);
  }

  // Render products for current page
  function renderProducts() {
    if (allProducts.length === 0) {
      productGrid.innerHTML =
        '<div class="grid__item text-center"><p>No products found in this collection.</p></div>';
      paginationElement.innerHTML = "";
      return;
    }

    // Filter products if hide sold out is enabled
    const filteredProducts = hideSoldOut
      ? allProducts.filter((product) => product.available)
      : allProducts;

    if (filteredProducts.length === 0) {
      productGrid.innerHTML =
        '<div class="grid__item text-center"><p>No in-stock products found. <a href="#" id="show-all-link">Show all products</a></p></div>';

      // Add event listener to the "Show all products" link
      document
        .getElementById("show-all-link")
        .addEventListener("click", function (e) {
          e.preventDefault();
          hideSoldOutCheckbox.checked = false;
          hideSoldOut = false;
          localStorage.setItem("hideSoldOut", "false");
          renderProducts();
        });

      paginationElement.innerHTML = "";
      return;
    }

    // Update product count to reflect filtered products
    productCount.textContent = filteredProducts.length;

    // Calculate pagination
    const totalProducts = filteredProducts.length;
    const totalPages = Math.ceil(totalProducts / productsPerPage);

    // Ensure current page is valid
    currentPage = Math.max(1, Math.min(currentPage, totalPages));

    // Get products for current page
    const startIndex = (currentPage - 1) * productsPerPage;
    const endIndex = Math.min(startIndex + productsPerPage, totalProducts);
    const currentPageProducts = filteredProducts.slice(startIndex, endIndex);

    // Clear the product grid
    productGrid.innerHTML = "";

    // Create grid items with 4-column layout that's responsive
    currentPageProducts.forEach((product) => {
      // Create grid item with responsive class
      const gridItem = document.createElement("div");
      gridItem.className = "grid__item small--one-half medium-up--one-quarter"; // 4 per row on desktop, 2 per row on mobile

      // Get first available variant (if any)
      const firstAvailableVariant = product.variants.find((variant) =>
        isVariantAvailable(variant.id)
      );
      const firstVariant = product.variants[0];
      const variantId = firstAvailableVariant
        ? firstAvailableVariant.id
        : firstVariant.id;

      // Ensure image URL is valid
      let imageUrl = product.featured_image || "";
      if (
        imageUrl &&
        !imageUrl.startsWith("http://") &&
        !imageUrl.startsWith("https://")
      ) {
        // If image path is relative, make sure it starts with a slash
        imageUrl = imageUrl.startsWith("/") ? imageUrl : "/" + imageUrl;
      }

      // Generate variant price data
      const variantPrices = generateVariantPriceData(product.variants);

      // Generate dropdown HTML based on product availability
      let dropdownHtml = "";
      if (!product.available) {
        // For out of stock products, just show a single "Sold Out" option
        dropdownHtml = `
          <div class="custom-dropdown-wrapper">
            <span class="custom-dropdown__small sold-out">
              <select title="Select variant" last="${product.variants[0].id}" name="id" data-dropdown-id="productSelect-dropdown" className="collection__select">
                <option>Sold Out</option>
              </select>
            </span>
          </div>
        `;
      } else {
        // For in-stock products, show all variants with availability checks
        dropdownHtml = `
  <div class="custom-dropdown-wrapper">
    <span class="custom-dropdown__small">
      <select title="Select variant" last="${
        firstAvailableVariant ? firstAvailableVariant.id : firstVariant.id
      }" name="id" data-dropdown-id="productSelect-dropdown" class="collection__select" id="variant-${
          product.id
        }" data-product-id="${product.id}">
        ${product.variants
          .map((variant) => {
            const isAvailable = isVariantAvailable(variant.id);
            const availableQty = getAvailableQuantity(variant.id);
            return `<option 
            value="${variant.id}" 
            ${!isAvailable ? "disabled" : ""} 
            ${variant.id === variantId ? "selected" : ""}
            data-available="${isAvailable}"
            data-qty="${availableQty}"
            class="${!isAvailable ? "sold-out-option" : ""}">
            ${variant.title === "Default Title" ? "Available" : variant.title}${
              !isAvailable ? " - Sold Out" : ""
            }
          </option>`;
          })
          .join("")}
      </select>
    </span>
  </div>
`;
      }

      // Create product card HTML
      const productCardHtml = `
        <div class="product-item ${!product.available ? "out-of-stock" : ""}">
          <div class="product-image-wrapper">
            ${
              !product.available
                ? '<div class="sold-out-label">SOLD OUT</div>'
                : product.on_sale
                ? '<div class="sale-label">SALE</div>'
                : ""
            }
            
            <a href="${product.url}">
              <img src="${imageUrl}" alt="${
        product.title
      }" class="product-image" onerror="this.onerror=null; this.src='/assets/no-image.jpg';">
            </a>
            
            <!-- Hover action buttons -->
            <div class="product-hover-actions">
              <a href="${
                product.url
              }" class="product-hover-btn" title="Quick view">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"/>
                  <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"/>
                </svg>
              </a>
              
              ${
                firstAvailableVariant
                  ? `<button class="product-hover-btn cart-btn" title="Add to cart" data-product-id="${product.id}" data-variant-id="${variantId}">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5zM3.102 4l1.313 7h8.17l1.313-7H3.102zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
                  </svg>
                </button>`
                  : ""
              }
            </div>
          </div>
          
          <div class="product-info text-center">
            <a href="${product.url}" class="product-title-link ${
        !product.available ? "sold-out-link" : ""
      }">
              <h3 class="product-title">${product.title}</h3>
            </a>
            
            <div class="product-price theme-color" variants='${variantPrices}' id="price-${
        product.id
      }">
              ${
                product.on_sale
                  ? `<span class="product-price__compare-at-price regular qv-discountprice" style="text-decoration: line-through;">${formatMoney(
                      product.compare_at_price
                    )}</span>
                 <span class="product-price__value">${formatMoney(
                   product.price
                 )}</span>`
                  : `<span class="product-price__value">${formatMoney(
                      product.price
                    )}</span>`
              }
            </div>
            
            <!-- Custom dropdown for variant selection -->
            ${dropdownHtml}
            
            <!-- Action button -->
            <div class="action-button-wrapper">
              ${
                product.available
                  ? `<button class="btn btn-primary view-details-btn add-to-cart-btn" id="add-btn-${
                      product.id
                    }" data-product-id="${
                      product.id
                    }" data-variant-id="${variantId}">
                  ${isVariantAvailable(variantId) ? "ADD TO CART" : "SOLD OUT"}
                </button>`
                  : `<a href="${product.url}" class="btn btn-primary view-details-btn">VIEW DETAILS</a>`
              }
            </div>
          </div>
        </div>
      `;

      gridItem.innerHTML = productCardHtml;
      productGrid.appendChild(gridItem);

      // Only update button state if product is available
      if (product.available) {
        const button = document.getElementById(`add-btn-${product.id}`);
        const select = document.getElementById(`variant-${product.id}`);

        if (button && select) {
          const selectedOption = select.options[select.selectedIndex];
          const isAvailable =
            selectedOption.getAttribute("data-available") === "true";

          if (!isAvailable) {
            button.disabled = true;
            button.classList.add("disabled");
            button.textContent = "SOLD OUT";
          } else {
            button.disabled = false;
            button.classList.remove("disabled");
            button.textContent = "ADD TO CART";
          }
        }
      }
    });

    // Initialize cart functionality
    initializeCartFunctionality();

    // Initialize variant change events
    initializeVariantChangeEvents();

    // Render pagination
    renderPagination(totalPages);
  }

  // Initialize variant change events to update prices
  function initializeVariantChangeEvents() {
    document
      .querySelectorAll(".custom-dropdown__small select[data-product-id]")
      .forEach((select) => {
        // Set initial state of select element based on selected option
        const initialSelectedOption = select.options[select.selectedIndex];
        const initialIsAvailable =
          initialSelectedOption.getAttribute("data-available") === "true";

        if (!initialIsAvailable) {
          select.closest(".custom-dropdown__small").classList.add("sold-out");
        } else {
          select
            .closest(".custom-dropdown__small")
            .classList.remove("sold-out");
        }

        select.addEventListener("change", function () {
          const productId = this.getAttribute("data-product-id");
          const variantId = this.value;
          const selectedOption = this.options[this.selectedIndex];
          const isAvailable =
            selectedOption.getAttribute("data-available") === "true";

          // Update select element styling based on selection
          if (!isAvailable) {
            this.closest(".custom-dropdown__small").classList.add("sold-out");
          } else {
            this.closest(".custom-dropdown__small").classList.remove(
              "sold-out"
            );
          }

          // Update add to cart button
          const addButton = document.getElementById(`add-btn-${productId}`);
          if (addButton) {
            addButton.setAttribute("data-variant-id", variantId);

            if (!isAvailable) {
              addButton.disabled = true;
              addButton.classList.add("disabled");
              addButton.textContent = "SOLD OUT";

              // Update cursor for the product container
              const productContainer = addButton.closest(".product-item");
              if (productContainer) {
                productContainer.classList.add("out-of-stock");
              }
            } else {
              addButton.disabled = false;
              addButton.classList.remove("disabled");
              addButton.textContent = "ADD TO CART";

              // Reset cursor for the product container
              const productContainer = addButton.closest(".product-item");
              if (productContainer) {
                productContainer.classList.remove("out-of-stock");
              }
            }
          }

          // Update cart hover button
          const cartHoverBtn = document.querySelector(
            `.cart-btn[data-product-id="${productId}"]`
          );
          if (cartHoverBtn) {
            cartHoverBtn.setAttribute("data-variant-id", variantId);

            if (!isAvailable) {
              cartHoverBtn.disabled = true;
              cartHoverBtn.classList.add("disabled");
              cartHoverBtn.style.cursor = "not-allowed";
            } else {
              cartHoverBtn.disabled = false;
              cartHoverBtn.classList.remove("disabled");
              cartHoverBtn.style.removeProperty("cursor");
            }
          }

          // Update price display with out-of-stock styling
          updatePriceDisplay(productId, variantId, !isAvailable);
        });
      });
  }

  function updatePriceDisplay(productId, variantId, isOutOfStock = false) {
    const priceContainer = document.getElementById(`price-${productId}`);
    if (!priceContainer) return;

    // Get variant prices from data attribute
    const variantPrices = JSON.parse(priceContainer.getAttribute("variants"));
    if (!variantPrices || !variantPrices[variantId]) return;

    const variantPrice = variantPrices[variantId];
    const price = variantPrice.price;
    const compareAtPrice = variantPrice.compareAtPrice;

    // Add out-of-stock class to control styling
    const outOfStockClass = isOutOfStock ? "out-of-stock-price" : "";

    // Create price HTML with the updated value class
    if (compareAtPrice && compareAtPrice > price) {
      priceContainer.innerHTML = `
        <span class="product-price__compare-at-price regular qv-discountprice ${outOfStockClass}" style="text-decoration: line-through;">${formatMoney(
        compareAtPrice
      )}</span>
        <span class="product-price__value ${outOfStockClass}">${formatMoney(
        price
      )}</span>
      `;
    } else {
      priceContainer.innerHTML = `<span class="product-price__value ${outOfStockClass}">${formatMoney(
        price
      )}</span>`;
    }
  }

  // Initialize cart functionality
  function initializeCartFunctionality() {
    // Add event listeners for cart buttons
    document
      .querySelectorAll(
        ".cart-btn:not(.disabled), .add-to-cart-btn:not(.disabled)"
      )
      .forEach((button) => {
        button.addEventListener("click", function (e) {
          e.preventDefault();
          const productId = this.getAttribute("data-product-id");
          const variantId = parseInt(this.getAttribute("data-variant-id"));

          // Find the associated select element
          const selectElement = document.querySelector(
            `.custom-dropdown__small select[data-product-id="${productId}"]`
          );
          if (!selectElement) return;

          // Get the selected variant id (which might have changed)
          const selectedVariantId = parseInt(selectElement.value);

          // Make sure we're using the current variant ID
          const currentVariantId = selectedVariantId || variantId;

          // Get selected option to check availability
          const selectedOption =
            selectElement.options[selectElement.selectedIndex];
          const isAvailable =
            selectedOption.getAttribute("data-available") === "true";
          const availableQty = parseInt(
            selectedOption.getAttribute("data-qty") || "0"
          );

          // Check if variant is available
          if (!isAvailable || availableQty <= 0) {
            showNotification("This product is out of stock", false);
            return;
          }

          // Show loading state
          this.classList.add("loading");
          this.disabled = true;

          // Add to cart using standard Shopify AJAX API
          fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({
              id: currentVariantId,
              quantity: 1,
            }),
          })
            .then((response) => {
              if (!response.ok) {
                return response.json().then((errorData) => {
                  throw { status: response.status, data: errorData };
                });
              }
              return response.json();
            })
            .then((data) => {
              // Reset button state
              this.classList.remove("loading");
              this.disabled = false;

              // Update local inventory tracking
              updateInventoryAfterAdd(currentVariantId, 1);

              // Show success notification with product title
              const productTitle = document
                .querySelector(`#price-${productId}`)
                .closest(".product-info")
                .querySelector(".product-title").textContent;
              const variantTitle = selectedOption.textContent.replace(
                " - Sold Out",
                ""
              );

              showNotification(
                `Added To Cart : ${productTitle} - ${variantTitle}`,
                true
              );

              // Refresh cart count and cart drawer
              refreshCart();

              // Update UI if item is now out of stock
              if (getAvailableQuantity(currentVariantId) <= 0) {
                updateVariantAvailability(currentVariantId, false);
              }
            })
            .catch((error) => {
              console.error("Error adding to cart:", error);

              // Reset button state
              this.classList.remove("loading");
              this.disabled = false;

              // Show appropriate error message
              let errorMessage = "Failed to add item to cart.";

              if (error.status === 422 && error.data && error.data.message) {
                errorMessage = `Add To Cart Failed : ${error.data.message}`;
              }

              showNotification(errorMessage, false);
            });
        });
      });
  }

  // Update local inventory tracking after adding to cart
  function updateInventoryAfterAdd(variantId, quantity) {
    if (inventoryTracking[variantId]) {
      // Only update if inventory is tracked by Shopify
      if (
        inventoryTracking[variantId].inventory_management === "shopify" &&
        inventoryTracking[variantId].inventory_policy !== "continue"
      ) {
        // Track in cart
        lineItems[variantId] = (lineItems[variantId] || 0) + quantity;

        // If inventory is now 0, update available status
        if (getAvailableQuantity(variantId) <= 0) {
          updateVariantAvailability(variantId, false);
        }

        // Save updated inventory to cache
        saveToCache();
      }
    }
  }

  // Update UI for variant availability
  function updateVariantAvailability(variantId, isAvailable) {
    // Update all option elements for this variant
    document
      .querySelectorAll(`option[value="${variantId}"]`)
      .forEach((option) => {
        option.setAttribute("data-available", isAvailable ? "true" : "false");
        option.setAttribute("data-qty", isAvailable ? "1" : "0"); // Simple flag

        // Update option text
        if (!isAvailable && !option.textContent.includes("Sold Out")) {
          option.textContent = "Sold Out";
        }
      });

    // Update all dropdowns that contain this variant
    document
      .querySelectorAll(`.custom-dropdown__small select`)
      .forEach((select) => {
        const hasThisVariant = Array.from(select.options).some(
          (option) => parseInt(option.value) === variantId
        );
        if (hasThisVariant) {
          // If this is the selected variant and it's not available, update the dropdown styling
          if (parseInt(select.value) === variantId && !isAvailable) {
            select.closest(".custom-dropdown__small").classList.add("sold-out");
          } else if (parseInt(select.value) === variantId && isAvailable) {
            select
              .closest(".custom-dropdown__small")
              .classList.remove("sold-out");
          }
        }
      });

    // Update all buttons for this variant
    document
      .querySelectorAll(`[data-variant-id="${variantId}"]`)
      .forEach((button) => {
        if (!isAvailable) {
          button.disabled = true;
          button.classList.add("disabled");
          if (button.classList.contains("add-to-cart-btn")) {
            button.textContent = "SOLD OUT";
          }
          if (button.classList.contains("cart-btn")) {
            button.style.cursor = "not-allowed";
          }
        } else {
          button.disabled = false;
          button.classList.remove("disabled");
          if (button.classList.contains("add-to-cart-btn")) {
            button.textContent = "ADD TO CART";
          }
          if (button.classList.contains("cart-btn")) {
            button.style.removeProperty("cursor");
          }
        }
      });

    // Update inventory tracking
    if (inventoryTracking[variantId]) {
      inventoryTracking[variantId].available = isAvailable;
    }
  }

  // Refresh cart using theme's existing functionality
  function refreshCart() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        // Update cart count display
        const cartCountElements = document.querySelectorAll(".cart-qty");
        cartCountElements.forEach((element) => {
          element.textContent = cart.item_count;
        });

        // Rebuild cart dropdown content
        rebuildCartDropdown(cart);

        // Dispatch Shopify standard cart events
        document.dispatchEvent(
          new CustomEvent("cart:create", { detail: cart })
        );
        document.dispatchEvent(
          new CustomEvent("cart:updated", { detail: cart })
        );
        document.dispatchEvent(
          new CustomEvent("cart:loaded", { detail: cart })
        );

        // Also trigger the standard ajaxCart.load() if it exists
        if (
          typeof ajaxCart !== "undefined" &&
          typeof ajaxCart.load === "function"
        ) {
          ajaxCart.load();
        }
      })
      .catch((error) => {
        console.error("Error updating cart:", error);
      });
  }

  // Function to rebuild the cart dropdown content
  function rebuildCartDropdown(cart) {
    const dropdownContainers = document.querySelectorAll(
      ".cart-dropdown-inner"
    );

    dropdownContainers.forEach((container) => {
      // Get references to all required elements
      const productList = container.querySelector(".product-list");
      const cartEmpty = container.querySelector(".cart__empty");
      const cartFooter = container.querySelector(".cart__footer");
      const cartSubtotal = container.querySelector(".cart__subtotal");

      if (!productList) return;

      // Clear existing product list
      productList.innerHTML = "";

      // Handle empty cart
      if (cart.item_count === 0) {
        if (cartEmpty) cartEmpty.classList.remove("hide");
        if (cartFooter) cartFooter.classList.add("hide");
        return;
      }

      // Cart has items
      if (cartEmpty) cartEmpty.classList.add("hide");
      if (cartFooter) cartFooter.classList.remove("hide");

      // Update subtotal
      if (cartSubtotal) {
        cartSubtotal.textContent = theme.Currency.formatMoney(
          cart.total_price,
          theme.moneyFormat
        );
      }

      // Add each item to the product list
      cart.items.forEach((item) => {
        // Create cart item element
        const cartItemHTML = buildCartItemHTML(item);
        productList.insertAdjacentHTML("beforeend", cartItemHTML);
      });
    });
  }

  // Helper function to build cart item HTML
  function buildCartItemHTML(item) {
    // Format prices
    const itemPrice = theme.Currency.formatMoney(
      item.final_line_price,
      theme.moneyFormat
    );

    // Create image URL
    let imageUrl = item.image;
    if (!imageUrl) {
      imageUrl =
        "//cdn.shopify.com/s/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif";
    }

    // Build HTML to match the slimScrollDiv structure in your second example
    return `
    <div class="product">
      <div class="product-img">
        <img loading="lazy" src="${imageUrl}" alt="${item.title}">
      </div>
      <div class="product-data">
        <a href="${item.url}" class="product-title">${item.title}</a>
        <span class="product-price">${
          item.quantity
        } x ${theme.Currency.formatMoney(item.price, theme.moneyFormat)}</span>
      </div>
      <a class="remove" data-variantid="${item.variant_id}">
        <i class="material-icons">delete</i>
      </a>
    </div>
  `;
  }

  // Render pagination
  // Render pagination
  function renderPagination(totalPages) {
    if (totalPages <= 1) {
      paginationElement.innerHTML = "";
      return;
    }

    let html = '<ul class="pagination">';

    // Previous button
    if (currentPage > 1) {
      html += `<li><a href="#" data-page="${
        currentPage - 1
      }" class="btn btn--secondary">« PREVIOUS</a></li>`;
    } else {
      html += `<li class="disabled"><span class="btn btn--secondary disabled">« PREVIOUS</span></li>`;
    }

    // Page numbers
    const maxVisiblePages = 5;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      if (i === currentPage) {
        html += `<li class="active"><span class="current">${i}</span></li>`;
      } else {
        html += `<li><a href="#" data-page="${i}">${i}</a></li>`;
      }
    }

    // Next button
    if (currentPage < totalPages) {
      html += `<li><a href="#" data-page="${
        currentPage + 1
      }" class="btn btn--secondary">NEXT »</a></li>`;
    } else {
      html += `<li class="disabled"><span class="btn btn--secondary disabled">NEXT »</span></li>`;
    }

    html += "</ul>";

    paginationElement.innerHTML = html;

    // Add click event to pagination links
    paginationElement.querySelectorAll("a").forEach((link) => {
      link.addEventListener("click", function (e) {
        e.preventDefault();

        const page = parseInt(this.dataset.page) || 1;
        currentPage = page;

        // Update URL
        updateURL();

        // Scroll to top
        window.scrollTo({ top: 0, behavior: "smooth" });

        // Re-render products with new page
        renderProducts();
      });
    });
  }
  // Handle browser back/forward buttons
  window.addEventListener("popstate", function (event) {
    if (event.state) {
      currentPage = event.state.page || 1;
      sortDirection = event.state.sort || "asc";
      updateSortButtons();
      renderProducts();
    }
  });

  // Start the process
  fetchCollection();
});
